import { render } from "./ServersCard.vue?vue&type=template&id=710067dd&scoped=true"
import script from "./ServersCard.vue?vue&type=script&lang=ts"
export * from "./ServersCard.vue?vue&type=script&lang=ts"

import "./ServersCard.vue?vue&type=style&index=0&id=710067dd&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-710067dd"

export default script